module.exports = {
  lange: {
    hversion: '版本',
    zsize: '大小',
    updateTime: '更新时间',
    Android: '安卓下载',
    Apple: '苹果下载',
    title: '或扫描下方二维码下载',
    QRcode: '扫描二维码下载',
    mobile: '或用手机浏览器输入这个网址：',
    facilityAndroid: '适用于安卓手机',
    facilityiPhone: '适用于苹果手机',
    ilucode: '撸码分发',
    disclaimer: '免责声明',
    report: '举报',
    install: '安装中...请查看桌面!',
    explain: '作为第三方内测分发平台，我们一直致力于打击违规应用，保护用户权益。非常感谢您的举报，我们会在第一时间安排专人处理您的举报问题。感谢您对我们的支持。',
    reptype: '请选择举报类型：',
    pirate: '盗版',
    yellow: '黄色',
    cheat: "欺诈",
    other: '其他',
    Reasons: '举报原因：',
    replenish: '请补充一下举报原因...',
    email: '邮箱：',
    write: '请填写邮箱地址',
    affirm: '举 报',
    back: '取 消',
    phone: '电话号码：',
    mobiles: '请输入您的手机号',
    one: '请选择举报类型',
    two: '请补充原因',
    three: '请填写邮箱',
    four: '请填写正确的邮箱',
    five: '请填写您的手机号',
    six: '请填写正确的手机号',
    freeDown: '免费下载',
    introduction: '简介',
    ZeroScore: '0个评分',
    Rating: '评分及评论',
    age: '年龄',
    points: '满分 5 分',
    newFunction: '新功能',
    message: '信息',
    nstallation: '安装包大小',
    compatibility: '兼容性',
    language: '语言',
    grading: '年龄分级',
    price: '价格',
    compatibilityInfo: '需要iOS或更高版本。与iPhone、iPad和iPodtouch兼容。',
    limit: '限4年以上',
    free: '免费',
    tutorial: '安装教程',
    languageInfo: '简体中文',
    introduce: '应用介绍',
    remark: '备注',
    contact: '联系方式',
    password: '请输入密码',
    enter: '确认',
    phonecode: '验证码',
    tsphonecode: '请输入正确的验证码',
    inphonecode: '请输入图片验证码',
    errphonecode: '图片验证码错误',
    errcode: '密码错误',
    download: '下载安装',
    downipa: '“未受信任的企业级开发者”的解决办法',
    downsuper: '安装教程',
    instaling: '正在安装，请稍后......',
    iosDescribe: '信任开发者',
    superDescribe: '安装配置描述',
    iOSAndroid: '适用于安卓和苹果手机',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js